import { CompanyEditRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const editRoute = {
  path: 'edit',
  element: <CompanyEditRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Edit</span>,
  }),
};